import { IColor } from '@fluentui/react';
import React, { useCallback, useEffect } from 'react';


interface UseCloseColorPickerProps {
  isSelected: boolean;
  colorData: { Name: string; HexCode: string };
  setIsSelected: (isSelected: boolean) => void;
  updateColor: (name: string, color: IColor) => void;
}

export const useHandleCloseColorPicker = ({
  isSelected,
  colorData,
  setIsSelected,
  updateColor,
}: UseCloseColorPickerProps) => {
  const popupRef = React.useRef<HTMLDivElement | null>(null);
  const handleClickOutside = useCallback((event) => {
    if (popupRef.current && !popupRef.current.contains(event.target) && event.target.className) {
      const { className } = event.target;
      const isColorPicker = typeof className === 'string' && (className.includes('ColorPicker') || className.includes('delete_color_btn') || className.includes('TextField'));
      if (!isColorPicker) {
        colorData.HexCode && updateColor(colorData.Name, { hex: colorData.HexCode, str: colorData.HexCode } as IColor);
        setIsSelected(false);
      }
    }
  }, [colorData.HexCode, colorData.Name, setIsSelected, updateColor]);

  useEffect(() => {
    if (isSelected) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside, isSelected]);

  return { popupRef };
};


export const useCheckDuplicateColor = ({ allowDuplicates, paletteData, onUpdate }) => {
  const [isDuplicate, setIsDuplicate] = React.useState(false);
  useEffect(() => {
    isDuplicate && setIsDuplicate(false);
  }, [isDuplicate]);
  const onUpdateColor = useCallback((name, colorObj) => {
    if (!allowDuplicates) {
      const isDuplicateColor = paletteData.some(color => color.HexCode === colorObj.str);
      if (isDuplicateColor) {
        setIsDuplicate(true);
        return;
      }
    }
    onUpdate(name, colorObj);
    setIsDuplicate(false);
  }, [allowDuplicates, onUpdate, paletteData]);

  return {
    isDuplicate,
    onUpdateColor,
  };
};
